// table info
export const tableHeaders = ["Name", "Code", "Created By"];

export const columnNames = ["name", "code", "name"];

export const viewRoute = "/users/view";
